function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as t, jsx as l } from "react/jsx-runtime";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: a , size: c = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = h(), o = a !== null && a !== void 0 ? a : s ? r.colors.inverse : r.colors.neutralHigh;
    return /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: o,
                d: "M5.932 7.492h9.563c.308 0 .56-.252.56-.56a.562.562 0 00-.56-.56H5.932a.562.562 0 00-.56.56c0 .308.251.56.56.56zm0 3.401h9.563c.308 0 .56-.252.56-.56a.562.562 0 00-.56-.56H5.932a.562.562 0 00-.56.56c0 .308.251.56.56.56z"
            }),
            /* @__PURE__ */ l("path", {
                fill: o,
                d: "M5.876 21.837h9.619c1.213 0 2.162-.353 2.818-1.045.616-.653.93-1.563.93-2.703v-3.107c0-.02-.002-.039-.003-.058 1.044-.93 1.933-1.725 2.064-1.855a1.85 1.85 0 00.577-1.328 1.975 1.975 0 00-.568-1.375c-.512-.51-1.334-.735-2.07-.43v-3.96c0-2.38-1.401-3.803-3.748-3.803h-9.62c-2.347 0-3.747 1.423-3.747 3.804v12.112c0 1.14.313 2.05.93 2.703.655.694 1.605 1.045 2.818 1.045zm12.246-11.03c-.575.517-1.582 1.411-2.66 2.366h-9.53a.562.562 0 00-.56.56c0 .308.251.56.56.56h8.263l-1.3 1.149a.561.561 0 00-.16.24l-.298.891H5.932a.562.562 0 00-.56.56c0 .309.251.56.56.56h6.13l-.287.855a.56.56 0 00.706.711l2.87-.949a.528.528 0 00.197-.112c.25-.221 1.38-1.22 2.574-2.281v2.172c0 1.742-.885 2.627-2.627 2.627h-9.62c-1.742 0-2.627-.885-2.627-2.627V5.977c0-.852.213-1.513.63-1.967.437-.476 1.11-.717 1.998-.717h9.619c.888 0 1.56.241 1.997.717.417.454.63 1.115.63 1.967v4.83zm-4.927 7.038l.557-1.661.148-.13c1.165-1.03 5.208-4.601 5.505-4.895.46-.46.964-.157 1.12 0a.853.853 0 01.241.58c0 .196-.084.375-.243.535-.227.224-3.46 3.09-5.63 5.01l-1.698.561z"
            })
        ]
    }));
}, f = n;
export { f as default };
